import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, BookOpen } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StickyCall from "../components/StickyCall";
import { articles } from "../articles";

export const formatDate = (d) => new Date(d).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export function ArticleCard({ a }) {
  return (
    <Link data-testid={`article-card-${a.slug}`} to={`/articles/${a.slug}`} className="card-onyx rounded-xl p-6 flex flex-col group h-full">
      <div className="text-[11px] uppercase tracking-[0.25em] text-gold-deep mb-2">{a.category} • {formatDate(a.date)}</div>
      <h2 className="font-display text-lg text-gold mb-3 leading-snug">{a.title}</h2>
      <p className="text-sm text-gold-soft/95 leading-relaxed flex-1">{a.description}</p>
      <span className="text-xs text-gold mt-4 flex items-center gap-1">Lire l'article <ChevronRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" /></span>
    </Link>
  );
}

export default function Articles() {
  return (
    <div data-testid="articles-page">
      <Header />
      <StickyCall />
      <section className="hero-radial py-14 md:py-20">
        <div className="container-narrow text-center max-w-3xl mx-auto">
          <BookOpen className="w-8 h-8 text-gold mx-auto mb-3" />
          <h1 className="font-display text-4xl md:text-5xl gold-gradient-text">Le blog de Maître Diamma</h1>
          <div className="gold-divider my-5 max-w-[220px] mx-auto" />
          <p className="text-gold-soft/95 leading-relaxed">Sorcellerie, désenvoûtement, retour affectif, magie blanche et voyance à Orléans : les conseils d'un marabout africain.</p>
        </div>
      </section>
      <section className="py-14 md:py-16 bg-charcoal">
        <div className="container-narrow grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((a) => <ArticleCard key={a.slug} a={a} />)}
        </div>
      </section>
      <Footer />
    </div>
  );
}
